import {IssuesLoadingSkeleton} from '@github-ui/issues-loading-skeleton'
import {NavList} from '@primer/react'

import {LABELS} from '../../constants/labels'
import {VALUES} from '../../constants/values'
import useKnownViews from '../../hooks/use-known-views'
import {CallToActionItem} from '../CallToActionItem'
import {AppTitle} from './AppTitle'
import {iconToPrimerIcon} from './IconHelper'
import {SavedViewItem} from './SavedViewItem'
import styles from './SidebarLoading.module.css'
import {SidebarRow} from './SidebarRow'

export function SidebarLoading() {
  const {knownViews} = useKnownViews()

  const savedViewsItems = knownViews
    .filter(view => !view.hidden)
    .map((item, index) => {
      if (item.url) {
        return (
          <SidebarRow
            key={item.id}
            icon={iconToPrimerIcon(item.icon)!}
            id={item.id}
            path={item.url}
            title={item.name}
            tooltip=""
          />
        )
      }

      return (
        <SavedViewItem
          key={item.id}
          id={item.id}
          icon={item.icon}
          color={VALUES.defaultViewColor}
          title={item.name}
          query={item.query}
          position={index + 1}
        />
      )
    })

  return (
    <nav aria-labelledby="sidebar-title" className={styles.SidebarLoadingContainer}>
      <div className="sr-only" aria-hidden="true">
        <AppTitle />
      </div>
      <NavList aria-label={LABELS.defaultViews} className={styles.SavedViewsList}>
        {savedViewsItems}
      </NavList>
      <NavList className={styles.LoadingViewsList}>
        {[...Array(VALUES.viewLoadingSize)].map((_, index) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <NavList.Item key={index}>
            <NavList.LeadingVisual>
              <IssuesLoadingSkeleton borderRadius="elliptical" height="md" width="md" />
            </NavList.LeadingVisual>
            <IssuesLoadingSkeleton height="sm" width={'random'} />
          </NavList.Item>
        ))}
      </NavList>
      <div className={styles.sidebarLoadingFooter}>
        <div className={styles.ctaContainer}>
          <CallToActionItem />
        </div>
      </div>
    </nav>
  )
}
